<!-- <div class="timeout-modal">

  <div class="icon-wrapper">
    <mat-icon>schedule</mat-icon>
  </div>

  <h2>Session timeout warning</h2>

  <p>
    You've been inactive. You'll be automatically logged out in:
  </p>

  <div class="timer">
    {{ minutes }}:{{ seconds < 10 ? '0' + seconds : seconds }} </div>

      <p>logging out...</p>

      <hr>

      <div class="btn-wrapper">

        <button mat-stroked-button color="primary" (click)="stayLoggedIn()">
          Stay logged in
        </button>

        <button mat-stroked-button color="warn" (click)="logoutNow()">
          Log out now
        </button>

      </div>

  </div> -->

<div class="custom-dialog-container">

  <div class="dialog-header">
    <h2>{{dictionaryContent?.['b2b.global.sessionabouttoexpire'] || 'Your session is about to expire'}}</h2>
  </div>

  <div class="dialog-body">
    <div class="body-title">
      <p>
        {{dictionaryContent?.['b2b.global.sessionexpireinactivity'] || 'Your session will expire due to inactivity. You can continue your current session or log out now.'}}
      </p>

      <p class="mt-4">
        {{dictionaryContent?.['b2b.global.autologout2min'] || 'You will be automatically logged out in 2 minutes'}}
      </p>
    </div>
  </div>

  <div class="dialog-footer btn-right">
    <div class="btn-group">
      <button mat-button class="mdc-button button--primary-small cdkFocusInitial" (click)="logoutNow()">
        Log out
      </button>

      <button mat-button class="mdc-button button--primary-small cdkFocusInitial" (click)="stayLoggedIn()">
        Continue
      </button>
    </div>
  </div>
</div>